//* Libraries imports
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@app/store";
import { useParams } from "react-router-dom";

//* Components imports
import { fetchTemplateById, TemplateActions } from "./TemplateSlice";
import { TemplateMainContent } from "./TemplateMainContent";

export function TemplateGenarateDocument() {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const { currentItem, loading } = useSelector(
    (state: RootState) => state.template
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchTemplateById(id));
    }
    return () => {
      console.log("🧹 Limpando estado do formulário");
      dispatch(TemplateActions.clearCurrentItem());
    };
  }, [dispatch, id]);

  if (!id) {
    return (
      <div className="flex items-center justify-center w-full h-full min-h-screen bg-background-dark text-white">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-2">
            ID do documento não fornecido
          </h2>
          <p className="text-gray-400">
            Por favor, forneça um ID válido na URL (ex: ?id=...)
          </p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center w-full h-full min-h-screen bg-background-dark text-white">
        <div className="text-center">
          <p className="text-xl">Carregando...</p>
        </div>
      </div>
    );
  }

  return <TemplateMainContent data={currentItem} />;
}

export default TemplateGenarateDocument;
